export default "__VITE_ASSET__B22Joa$S__"